var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.reCaptchaValue.enabled)?_c('div',[_c('b-field',{staticClass:"mb-0",attrs:{"type":{'is-danger': !_vm.valid},"message":{ 'Bu alanı işaretlemelisin': !_vm.valid }}},[_c('vue-recaptcha',{attrs:{"sitekey":_vm.GOOGLE_RECAPTCHA_SITEKEY,"loadRecaptchaScript":true},on:{"verify":_vm.onVerify,"expired":_vm.onExpired}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }